import { collection, deleteDoc, doc, query as firebaseQuery, getDoc, getDocs, getFirestore, limit, orderBy, setDoc, startAfter, updateDoc, where } from 'firebase/firestore'
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage"
import { ID } from '../../../../../../_metronic/helpers'
import { getBoolean, getDateTime, getDropdownOptionsFromFirebase, removeEmptyAttributes, simpleSubsequencesForObject, checkIfIndexRequired } from '../../../../../../jsFunctions'
import { generatePaginationLinks, getValueByNumber } from '../../../../../../tsFunctions'
import { Event, EventsQueryResponse } from './_models'

const collection_name = "_activations";
const API_URL = process.env.REACT_APP_THEME_API_URL
const EVENT_URL = `${API_URL}/user`
const GET_EVENTS_URL = `${API_URL}/users/query`
interface DynamicObject {
  [key: string]: any;
}

const toValidStringArray = (items: any, useLowerCase = false): string[] => {
  if (!Array.isArray(items)) {
    return []
  }

  return items
    .map((item: any) => {
      if (typeof item === 'string') {
        return item.trim()
      }

      const rawValue = item?.id ?? item?.value ?? item?.uid
      if (typeof rawValue !== 'string') {
        return ''
      }

      return rawValue.trim()
    })
    .filter((value: string) => value.length > 0)
    .map((value: string) => (useLowerCase ? value.toLowerCase() : value))
}

const getMemoryMakerUid = (memoryMaker: any): string => {
  if (typeof memoryMaker === 'string') {
    return memoryMaker.trim()
  }

  const rawValue = memoryMaker?.uid ?? memoryMaker?.data?.uid ?? memoryMaker?.value ?? memoryMaker?.id

  return typeof rawValue === 'string' ? rawValue.trim() : ''
}

const getMemoryMakerLegacyIds = (memoryMaker: any): string[] => {
  if (typeof memoryMaker === 'string') {
    return [memoryMaker.trim()].filter(Boolean)
  }

  return [memoryMaker?.id, memoryMaker?.value, memoryMaker?.data?.id]
    .filter((value: any): value is string => typeof value === 'string' && value.trim().length > 0)
    .map((value: string) => value.trim())
}

const getEvents = async (query: string): Promise<EventsQueryResponse> => {
  const db = getFirestore()
  let params = new URLSearchParams(query);

  let sort = params.get('sort')
  let lastVisible = params.get('lastVisible')
  let page: number = Number(params.get('page'))
  let from: number = Number(params.get('from'))
  let search = params.get('search')?.toLowerCase()
  let order = params.get('order')
  let history = params.get('history')
  interface Filter {
    type: 'isMicrosite' | 'isDooh' | 'isAnalytics'; // replace with the actual types
    status: string
    // other properties...
  }
  let filter: Filter = Object({ type: params.get('filter_type'), status: params.get('filter_status') })
  const promises: Promise<void>[] = []; // Array to store promises

  const parseHistoryObj = (historyString: string) => {
    if (!historyString) return [];
    return JSON.parse(historyString);
  };

  const parsedHistory = parseHistoryObj(history as string);

  let startParam = getValueByNumber(page, parsedHistory, from, lastVisible);

  if (!lastVisible && startParam.value) {
    lastVisible = startParam.value
  }

  console.log("query ", query)
  console.log(": ", lastVisible, "\t", startParam.value);
  console.log(filter)

  let q = firebaseQuery(collection(db, collection_name), limit(6));

  if (lastVisible && page > 1) {
    const counter = page - from;
    const pageLimit = 5;
    let entries = pageLimit * counter + 1;
    if (from > page) {
      let startParam = getValueByNumber(page, parsedHistory, from, lastVisible);
      if (startParam.value) {
        lastVisible = startParam.value ? startParam.value : lastVisible
      }
      if (page === startParam.key) {
        entries = pageLimit + 1;
      }
      else {
        entries = pageLimit * (page - startParam.key) + 1;
      }
    }

    return getDoc(doc(db, collection_name, lastVisible)).then((docSnap) => {
      if (sort && (order === "desc" || order === "asc") && search) {
        q = firebaseQuery(collection(db, collection_name), where("zearch", "array-contains", search), orderBy(sort, order), startAfter(docSnap), limit(entries))

        if (filter.type) {
          q = firebaseQuery(collection(db, collection_name),
            orderBy(sort, order), startAfter(docSnap),
            limit(entries),
            where("zearch", "array-contains", search),
            where(filter.type, "array-contains", filter.status),
          )
        }
      }
      else if (sort && (order === "desc" || order === "asc")) {
        q = firebaseQuery(collection(db, collection_name), orderBy(sort, order), startAfter(docSnap), limit(entries))

        if (filter.type) {
          q = firebaseQuery(collection(db, collection_name),
            orderBy(sort, order),
            startAfter(docSnap),
            limit(entries),
            where(filter.type, "array-contains", filter.status),
            // where("zearch", "array-contains", filter.status == true ? filter.type : filter.type + "Disabled")
          )
        }
      }
      else if (search) {
        q = firebaseQuery(collection(db, collection_name), orderBy("dateCreated", "desc"), where("zearch", "array-contains", search), startAfter(docSnap), limit(entries))

        if (filter.type) {
          q = firebaseQuery(collection(db, collection_name),
            orderBy("dateCreated", "desc"),
            startAfter(docSnap),
            limit(entries),
            where(filter.type, "array-contains", filter.status),
            where("zearch", "array-contains", search),
            // where("zearch", "array-contains-any", filter.status == true ? [filter.type, search] : [filter.type + "Disabled", search])
          )
        }
      }
      else {
        q = firebaseQuery(collection(db, collection_name), orderBy("dateCreated", "desc"), limit(entries), startAfter(docSnap))
        if (filter.type) {
          q = firebaseQuery(collection(db, collection_name),
            orderBy("dateCreated", "desc"),
            limit(entries),
            startAfter(docSnap),
            where(filter.type, "array-contains", filter.status)
            // where("zearch", "array-contains", filter.status == true ? filter.type : filter.type + "Disabled")

          )
        }
      }

      return new Promise(resolve =>
        getDocs(q)
          .then(querySnapshot => {
            const eventsArr = Array()

            let docs = querySnapshot.docs.slice();
            let landingPage = Math.ceil((querySnapshot.size - 1) / pageLimit);
            if (querySnapshot.size === 1) {
              landingPage = 1;
            }
            if (page > from) {
              page = from + landingPage;
            }
            //remove entries for pages that are not required
            if (landingPage > 1) {
              const toSplice = ((landingPage - 1) * pageLimit);
              docs.splice(0, toSplice);
            }
            //remove one extra entry if page is not last page
            if (docs.length > pageLimit) {
              docs.splice(-1);
              lastVisible = docs[docs.length - 1].id;
            }
            else {
              lastVisible = null;
            }

            docs.forEach(document => {
              const user = document.data()
              if (!user.id) {
                alert("No user id found for " + document.id)
              }
              eventsArr.push({
                id: document.id,
                dateCreated: getDateTime(user.dateCreated?.seconds * 1000),
                updatedOn: user.updatedOn ? getDateTime(user.updatedOn.seconds * 1000) : getDateTime(new Date()),
                startDate: getDateTime(user.startDate?.seconds * 1000),
                endDate: getDateTime(user.endDate?.seconds * 1000),
                memoryMakers: user.memoryMakers,
                templates: user.templates,
                tags: user.tags,
                info: user.info,
                isAnalytics: getBoolean(user.isAnalytics, true),
                embedCode: user.embedCode ? user.embedCode : "",
                projectNo: user.projectNo,
                avatar: user.avatar ? user.avatar : "",
                name: user.name,
                isForm: getBoolean(user.isForm, true),
                form: user.form,
                qrCards: getBoolean(user.qrCards, true),
                initialToolFrame: getBoolean(user.initialToolFrame, true),
                isMail: getBoolean(user.isMail, true),
                sendgrid: user.sendgrid,
                wixMail: user.wixMail,
                mailType: user.mailType,
                qrMail: user.qrMail,
                mailParagraph: user.mailParagraph ? user.mailParagraph : "",
                isMicrosite: getBoolean(user.isMicrosite, true),
                microsite: user.microsite,
                isRouter: getBoolean(user.isRouter, true),
                router: user.router ? user.router : "",
                micrositeBeta: user.micrositeBeta,
                micrositeDate: user.micrositeDate?.seconds ? getDateTime(user.micrositeDate.seconds * 1000) : null,
                micrositeName: user.micrositeName,
                isDooh: getBoolean(user.isDooh, true),
                autoPrint: getBoolean(user.autoPrint, true),
                isPrintDefault: getBoolean(user.isPrintDefault, true),
                printableTemplateId: user.printableTemplateId,
                dooh: user.dooh,
                quitclaim: user.quitclaim,
                mailParagraphDooh: user.mailParagraphDooh ? user.mailParagraphDooh : "",
                sendgridDooh: user.sendgridDooh,
              })

              let parentPromise = getDropdownOptionsFromFirebase("id", "_clients", user.clients, user.owner[0], null, null, document.id).then(({ parent, owner, associatedCollections }) => {
                const index_ = eventsArr.findIndex(obj => obj.id === document.id);
                if (index_ !== -1) {
                  eventsArr[index_] = { ...eventsArr[index_], parent: owner, clients: parent, associatedCollections };
                }
              })

              promises.push(parentPromise);
            })

            return Promise.all(promises).then(() => {

              page = eventsArr.length ? page : 1

              resolve({
                data: eventsArr,
                payload: {
                  message: "N/A",
                  errors: {},
                  "pagination": {
                    page: page,
                    items_per_page: 10,
                    lastVisible: lastVisible,
                    "first_page_url": "/?page=1",
                    "from": 1,
                    "last_page": page,
                    "next_page_url": "\\/?page=" + (page + 1),
                    "prev_page_url": null,
                    "to": querySnapshot.docs.length + 1,
                    // "total": 21,
                    "history": { ...parsedHistory, [page]: eventsArr.length === pageLimit ? eventsArr[pageLimit - 1].id : null },
                    "links": generatePaginationLinks(page, lastVisible)
                  }
                }
              })
            })
          }).catch(error => {
            console.error(error)
            checkIfIndexRequired(error.message)
            resolve(error)
          }))
    })
  }
  else {

    const pageLimit = 5 * page;

    if (sort && (order === "desc" || order === "asc") && search) {
      q = firebaseQuery(collection(db, collection_name), where("zearch", "array-contains", search), orderBy(sort, order), limit(pageLimit + 1))

      if (filter.type) {
        q = firebaseQuery(collection(db, collection_name),
          orderBy(sort, order),
          limit(pageLimit + 1),
          where(filter.type, "array-contains", filter.status),
          where("zearch", "array-contains", search),
        )
      }
    }
    else if (sort && (order === "desc" || order === "asc")) {
      q = firebaseQuery(collection(db, collection_name), orderBy(sort, order), limit(pageLimit + 1))

      if (filter.type) {
        q = firebaseQuery(collection(db, collection_name),
          where(filter.type, "array-contains", filter.status),
          orderBy(sort, order),
          limit(pageLimit + 1))
      }
    }
    else if (search) {
      q = firebaseQuery(collection(db, collection_name), orderBy("dateCreated", "desc"), where("zearch", "array-contains", search), limit(pageLimit + 1))


      if (filter.type) {
        q = firebaseQuery(collection(db, collection_name),
          orderBy("dateCreated", "desc"),
          limit(pageLimit + 1),
          where(filter.type, "array-contains", filter.status),
          where("zearch", "array-contains", search),
        )
      }
    }
    else {
      q = firebaseQuery(collection(db, collection_name), orderBy("dateCreated", "desc"), limit(pageLimit + 1))

      if (filter.type) {
        q = firebaseQuery(collection(db, collection_name),
          where(filter.type, "array-contains", filter.status),
          orderBy("dateCreated", "desc"),
          limit(pageLimit + 1))
      }
    }

    // if (search) {
    //   q = firebaseQuery(q, where("zearch", "array-contains", search));
    // }

    // if (sort && (order === "desc" || order === "asc")) {
    //   q = firebaseQuery(q, orderBy(sort, order));
    // }

    // if (filter && filter.type) {
    //   q = firebaseQuery(q, where(filter.type, "array-contains", filter.status));
    // }

    // q = firebaseQuery(q, orderBy("dateCreated", "desc"), limit(pageLimit + 1));

    // console.log(q)


    return new Promise(resolve =>
      getDocs(q)
        .then(querySnapshot => {
          const eventsArr = Array()
          let index = 0;

          querySnapshot.forEach(document => {
            if (pageLimit > 5 && index < pageLimit - 5) {

            }
            else {
              const user = document.data()
              console.log(user.id)

              if (!user.id) {
                alert("No user id found for " + document.id)
              }
              // updateDoc(doc(db, collection_name, document.id), {
              //   startDate: new Date(),
              //   endDate: new Date()
              // });

              // console.log(user.startDate, " ", user.endDate, " ",user.dateCreated)
              // let parentPromise = getDropdownOptionsFromFirebase("id", "_clients", user.clients).then(({ parent }) => {
              //   eventsArr.push({
              //     id: document.id,
              //     dateCreated: getDateTime(user.dateCreated?.seconds * 1000),
              //     startDate: getDateTime(user.startDate?.seconds * 1000),
              //     endDate: getDateTime(user.endDate?.seconds * 1000),
              //     memoryMakers: user.memoryMakers,
              //     templates: user.templates,
              //     tags: user.tags,
              //     parent: parent,
              //     info: user.info,
              //     projectNo: user.projectNo,
              //     avatar: user.avatar ? user.avatar : "",
              //     name: user.name
              //   })
              // })

              eventsArr.push({
                id: document.id,
                dateCreated: getDateTime(user.dateCreated?.seconds * 1000),
                updatedOn: user.updatedOn ? getDateTime(user.updatedOn.seconds * 1000) : getDateTime(new Date()),
                startDate: getDateTime(user.startDate?.seconds * 1000),
                endDate: getDateTime(user.endDate?.seconds * 1000),
                memoryMakers: user.memoryMakers,
                templates: user.templates,
                tags: user.tags,
                info: user.info,
                isAnalytics: getBoolean(user.isAnalytics, true),
                embedCode: user.embedCode ? user.embedCode : "",
                projectNo: user.projectNo,
                avatar: user.avatar ? user.avatar : "",
                name: user.name,
                isForm: getBoolean(user.isForm, true),
                form: user.form,
                qrCards: getBoolean(user.qrCards, true),
                initialToolFrame: getBoolean(user.initialToolFrame, true),
                isMail: getBoolean(user.isMail, true),
                sendgrid: user.sendgrid,
                wixMail: user.wixMail,
                mailType: user.mailType,
                qrMail: user.qrMail,
                mailParagraph: user.mailParagraph ? user.mailParagraph : "",
                isMicrosite: getBoolean(user.isMicrosite, true),
                microsite: user.microsite,
                isRouter: getBoolean(user.isRouter, true),
                router: user.router ? user.router : "",
                micrositeBeta: user.micrositeBeta,
                micrositeDate: user.micrositeDate?.seconds ? getDateTime(user.micrositeDate.seconds * 1000) : null,
                micrositeName: user.micrositeName,
                isDooh: getBoolean(user.isDooh, true),
                autoPrint: getBoolean(user.autoPrint, true),
                isPrintDefault: getBoolean(user.isPrintDefault, true),
                printableTemplateId: user.printableTemplateId,
                dooh: user.dooh,
                quitclaim: user.quitclaim,
                mailParagraphDooh: user.mailParagraphDooh ? user.mailParagraphDooh : "",
                sendgridDooh: user.sendgridDooh,
              })

              let parentPromise = getDropdownOptionsFromFirebase("id", "_clients", user.clients, user.owner[0], null, null, document.id).then(({ parent, owner, associatedCollections }) => {
                const index_ = eventsArr.findIndex(obj => obj.id === document.id);

                if (index_ !== -1) {
                  eventsArr[index_] = { ...eventsArr[index_], parent: owner, clients: parent, associatedCollections };
                }
              })

              promises.push(parentPromise);
            }
            index++
          })
          return Promise.all(promises).then(() => {

            page = eventsArr.length ? page : 1

            lastVisible = eventsArr.length > 5 ? eventsArr[eventsArr.length - 2].id : null

            console.log(eventsArr)

            resolve({
              data: eventsArr.length > 5 ? eventsArr.slice(0, eventsArr.length - 1) : eventsArr,
              payload: {
                message: "N/A",
                errors: {},
                "pagination": {
                  page: page,
                  items_per_page: 10,
                  lastVisible: lastVisible,
                  "first_page_url": "/?page=1",
                  "from": 1,
                  // "last_page": 3,
                  "next_page_url": "\\/?page=" + (page + 1),
                  "prev_page_url": "\\/?page=" + (page - 1),
                  "to": querySnapshot.docs.length + 1,
                  // "total": 21,
                  "history": { ...parsedHistory, [page]: eventsArr.length > pageLimit ? eventsArr[pageLimit - 1].id : null },
                  "links": generatePaginationLinks(page, lastVisible)
                }
              }
            })
          })
        }).catch(error => {
          console.error(error)
          checkIfIndexRequired(error.message)
          resolve(error)
        }))
  }
}


interface dropdownOptions {
  readonly value: string;
  readonly avatar?: string;
  readonly label: string;
  readonly color: string;
  readonly id: string;
  readonly uid?: string;
  readonly isFixed?: boolean;
  readonly isDisabled?: boolean;
  readonly tags?: Array<string>
  readonly data?: any
}

type PrinterDevicesMap = Record<string, {enabled: boolean; label: string}>

const PRINTER_STATUS_COLLECTION = 'printerStatus'

const printerDevicesMapToOptions = (printerDevices: any): dropdownOptions[] => {
  if (!printerDevices || typeof printerDevices !== 'object' || Array.isArray(printerDevices)) {
    return []
  }

  return Object.entries(printerDevices)
    .filter(([, printerDevice]) => (printerDevice as any)?.enabled !== false)
    .map(([deviceId, printerDevice]) => {
      const device = printerDevice as {label?: string}

      return {
        value: deviceId,
        id: deviceId,
        label: device.label || deviceId,
        color: '#000',
        isFixed: true,
        isDisabled: false,
        tags: [deviceId.toLowerCase(), (device.label || deviceId).toLowerCase()],
      }
    })
}

const toPrinterDevicesMap = (printerDevices: any): PrinterDevicesMap => {
  if (!Array.isArray(printerDevices)) {
    return printerDevicesMapToOptions(printerDevices).reduce<PrinterDevicesMap>((acc, printerDevice) => {
      acc[printerDevice.value] = {
        enabled: true,
        label: printerDevice.label,
      }

      return acc
    }, {})
  }

  return printerDevices.reduce<PrinterDevicesMap>((acc, printerDevice: any) => {
    const deviceId = typeof printerDevice === 'string'
      ? printerDevice.trim()
      : (printerDevice?.value || printerDevice?.id || printerDevice?.deviceId || '').trim()

    if (!deviceId) {
      return acc
    }

    acc[deviceId] = {
      enabled: true,
      label: printerDevice?.label || printerDevice?.name || deviceId,
    }

    return acc
  }, {})
}

const getDefaultPrinterDeviceId = (defaultPrinterDeviceId: any, printerDevices: PrinterDevicesMap): string => {
  const printerDeviceIds = Object.keys(printerDevices)
  const normalizedDefaultPrinterDeviceId =
    typeof defaultPrinterDeviceId === 'string' ? defaultPrinterDeviceId.trim() : ''

  if (normalizedDefaultPrinterDeviceId && printerDeviceIds.includes(normalizedDefaultPrinterDeviceId)) {
    return normalizedDefaultPrinterDeviceId
  }

  return printerDeviceIds[0] || ''
}

const getPrinterAssignments = (
  printerAssignments: any,
  memoryMakers: any,
  printerDevices: PrinterDevicesMap
) => {
  const memoryMakerUids = new Set<string>()
  const memoryMakerIdToUid = new Map<string, string>()

  if (Array.isArray(memoryMakers)) {
    memoryMakers.forEach((memoryMaker: any) => {
      const memoryMakerUid = getMemoryMakerUid(memoryMaker)

      if (!memoryMakerUid) {
        return
      }

      memoryMakerUids.add(memoryMakerUid)
      getMemoryMakerLegacyIds(memoryMaker).forEach((memoryMakerId) => {
        memoryMakerIdToUid.set(memoryMakerId, memoryMakerUid)
      })
    })
  }

  const printerDeviceIds = new Set(Object.keys(printerDevices))
  const memoryMakerToDevice = printerAssignments?.memoryMakerToDevice || {}

  return {
    memoryMakerToDevice: Object.entries(memoryMakerToDevice).reduce<Record<string, string>>(
      (acc, [memoryMakerId, printerDeviceId]) => {
        const normalizedPrinterDeviceId = typeof printerDeviceId === 'string' ? printerDeviceId.trim() : ''
        const memoryMakerUid = memoryMakerUids.has(memoryMakerId)
          ? memoryMakerId
          : memoryMakerIdToUid.get(memoryMakerId)

        if (memoryMakerUid && printerDeviceIds.has(normalizedPrinterDeviceId)) {
          acc[memoryMakerUid] = normalizedPrinterDeviceId
        }

        return acc
      },
      {}
    ),
  }
}


const getTemplates = (): Promise<dropdownOptions[]> => {
  const db = getFirestore()
  let q = firebaseQuery(collection(db, "_templates"), orderBy('dateCreated', 'desc'))

  return new Promise(resolve =>
    getDocs(q)
      .then(querySnapshot => {

        const temlpatesArr: dropdownOptions[] = [];

        querySnapshot.forEach((doc) => {
          const template = doc.data()
          temlpatesArr.push({
            value: doc.id,
            avatar: template.image,
            id: doc.id,
            label: template.name,
            // label: template.dimensions?.width + " by " + template.dimensions?.height + " - " + doc.id,
            color: '#000',
            tags: template.tags ? template.tags : []
            // isFixed: true,
            // isDisabled: false,
          })
        })

        resolve(temlpatesArr)

      }).catch(error => {
        console.error(error)
        // resolve(dropdownOptions)
      }))
}


const getFrames = (): Promise<dropdownOptions[]> => {
  const db = getFirestore()
  let q = firebaseQuery(collection(db, "frames"), orderBy('updatedOn', 'desc'))

  return new Promise(resolve =>
    getDocs(q)
      .then(querySnapshot => {

        const framesArr: dropdownOptions[] = [];

        querySnapshot.forEach((doc) => {
          const frame = doc.data()
          framesArr.push({
            value: doc.id,
            avatar: frame.uri,
            id: doc.id,
            label: frame.width + " by " + frame.height,
            // label: template.dimensions?.width + " by " + template.dimensions?.height + " - " + doc.id,
            color: '#000',
            tags: frame.tags ? frame.tags : []
            // isFixed: true,
            // isDisabled: false,
          })
        })

        resolve(framesArr)

      }).catch(error => {
        console.error(error)
        // resolve(dropdownOptions)
      }))
}

const getClients = (): Promise<dropdownOptions[]> => {
  const db = getFirestore()
  let q = firebaseQuery(collection(db, "_clients"))

  return new Promise(resolve =>
    getDocs(q)
      .then(querySnapshot => {

        const clientsArr: dropdownOptions[] = [];

        querySnapshot.forEach((doc) => {
          const client = doc.data()
          clientsArr.push({
            value: client.id,
            id: client.id,
            label: client.name,
            color: '#000',
            isFixed: true,
            isDisabled: false,
            tags: []
          })
        })

        resolve(clientsArr)

      }).catch(error => {
        console.error(error)
      }))
}

// const getFrames = (): Promise<dropdownOptions[]> => {
//   const db = getFirestore()
//   let q = firebaseQuery(collection(db, "frames"))

//   return new Promise(resolve =>
//     getDocs(q)
//       .then(querySnapshot => {

//         const framesArr: dropdownOptions[] = [];

//         querySnapshot.forEach((doc) => {
//           const frame = doc.data()
//           framesArr.push({
//             value: doc.id,
//             avatar: frame.uri,
//             id: doc.id,
//             label: frame.meta.relativeScale + " - " + frame.height + " by " + frame.width,
//             color: '#000',
//             tags: frame.tags ? frame.tags : []
//           })
//         })

//         resolve(framesArr)

//       }).catch(error => {
//         console.error(error)
//         // resolve(dropdownOptions)
//       }))
// }

const getMemoryMakers = (uid: boolean): Promise<dropdownOptions[]> => {
  const db = getFirestore()
  let q = firebaseQuery(collection(db, "_users"), where("role", "==", "Memory Maker"))

  return new Promise(resolve =>
    getDocs(q)
      .then(querySnapshot => {

        const memoryMakersArr: dropdownOptions[] = [];

        querySnapshot.forEach((doc) => {
          const memoryMaker = doc.data()
          const fallbackId = memoryMaker.id || memoryMaker.uid || doc.id
          const memoryMakerUid = memoryMaker.uid || fallbackId

          memoryMakersArr.push({
            value: uid ? memoryMakerUid : fallbackId,
            id: uid ? memoryMakerUid : fallbackId,
            uid: memoryMakerUid,
            label: memoryMaker.name || memoryMaker.displayName || memoryMaker.email || fallbackId,
            // label: memoryMaker.email,
            color: '#000',
            isFixed: true,
            isDisabled: false,
            data: memoryMaker,
          })
        })

        resolve(memoryMakersArr)

      }).catch(error => {
        console.error(error)
        // resolve(dropdownOptions)
      }))
}

const getPrinterDevices = (): Promise<dropdownOptions[]> => {
  const db = getFirestore()
  const q = firebaseQuery(collection(db, PRINTER_STATUS_COLLECTION))

  return new Promise(resolve =>
    getDocs(q)
      .then(querySnapshot => {
        const printerDevicesArr: dropdownOptions[] = []

        querySnapshot.forEach((doc) => {
          const printerDevice = doc.data()
          const deviceId = printerDevice.deviceId || doc.id
          const label = printerDevice.label || printerDevice.name || printerDevice.displayName || deviceId

          printerDevicesArr.push({
            value: deviceId,
            id: deviceId,
            label,
            color: '#000',
            isFixed: true,
            isDisabled: false,
            tags: [
              doc.id.toLowerCase(),
              deviceId.toLowerCase(),
              label.toLowerCase(),
              printerDevice.status?.toLowerCase?.() || '',
            ].filter(Boolean),
          })
        })

        resolve(printerDevicesArr.sort((a, b) => a.label.localeCompare(b.label)))

      }).catch(error => {
        console.error(error)
        resolve([])
      }))
}

const getEventById = (id: ID): Promise<Event | undefined> => {
  const db = getFirestore()
  let q = firebaseQuery(collection(db, collection_name))
  q = firebaseQuery(collection(db, collection_name), where("id", "==", id))

  return new Promise(resolve =>
    getDocs(q)
      .then(querySnapshot => {
        const usersArr = Array()
        querySnapshot.forEach(doc => {
          const user = doc.data()
          getDropdownOptionsFromFirebase("id", "_clients", user.clients, user.owner[0], user.memoryMakers, user.templates, null, user.frames).then((sharedClients) => {
            console.log(user)
            console.log("sharedClients ", sharedClients)
            usersArr.push({
              id: doc.id,
              dateCreated: getDateTime(user.dateCreated.seconds * 1000),
              updatedOn: user.updatedOn ? getDateTime(user.updatedOn.seconds * 1000) : getDateTime(new Date()),
              startDate: new Date(user.startDate.seconds * 1000),
              endDate: new Date(user.endDate.seconds * 1000),
              tags: user.tags,
              memoryMakers: sharedClients.memoryMakers,
              printerDevices: printerDevicesMapToOptions(user.printerDevices),
              defaultPrinterDeviceId: user.defaultPrinterDeviceId || '',
              printerAssignments: user.printerAssignments || {
                memoryMakerToDevice: {},
              },
              exportFolder: user.exportFolder,
              templates: sharedClients.templates,
              frames: sharedClients.frames,
              // parent: user.owner,
              parent: sharedClients.owner,
              clients: sharedClients.parent,
              info: user.info,
              projectNo: user.projectNo,
              avatar: user.avatar ? user.avatar : "",
              name: user.name,
              isForm: getBoolean(user.isForm, false),
              isIntro: getBoolean(user.isIntro, false),
              intro: user.intro,
              form: user.form,
              qrCards: getBoolean(user.qrCards, false),
              initialToolFrame: getBoolean(user.initialToolFrame, false),
              isMail: getBoolean(user.isMail, false),
              sendgrid: user.sendgrid,
              wixMail: user.wixMail,
              mailType: user.mailType,
              qrMail: user.qrMail,
              mailParagraph: user.mailParagraph ? user.mailParagraph : "",
              isMicrosite: getBoolean(user.isMicrosite, false),
              isMicrositeDefault: getBoolean(user.isMicrositeDefault, false),
              microsite: user.microsite,
              isRouter: getBoolean(user.isRouter, false),
              router: user.router ? user.router : "",
              micrositeBeta: user.micrositeBeta,
              micrositeDate: user.micrositeDate?.seconds ? new Date(user.micrositeDate.seconds * 1000) : null,
              micrositeName: user.micrositeName,
              isDooh: getBoolean(user.isDooh, false),
              autoPrint: getBoolean(user.autoPrint, false),
              isPrintDefault: getBoolean(user.isPrintDefault, false),
              printableTemplateId: user.printableTemplateId,
              dooh: user.dooh,
              apiType: user.apiType,
              apiVersion: user.apiVersion,
              apiEnhance: getBoolean(user.apiEnhance),
              testingMode: getBoolean(user.testingMode),
              quitclaim: user.quitclaim,
              mailParagraphDooh: user.mailParagraphDooh ? user.mailParagraphDooh : "",
              sendgridDooh: user.sendgridDooh,
              isAnalytics: user.isAnalytics,
              embedCode: user.embedCode ? user.embedCode : "",
            })
            resolve(usersArr[0])
          })
        })

      }).catch(error => {
        console.error(error)
        resolve(error)
      }))
}

const uploadAndUpdate = (id: string, avatar: any, name: string) => {
  const db = getFirestore()
  const storage = getStorage()
  const storageRef = ref(storage, '/_activations/dp/' + name)
  // 'file' comes from the Blob or File API
  uploadBytes(storageRef, avatar).then((snapshot) => {
    getDownloadURL(snapshot.ref).then((downloadURL) => {
      updateDoc(doc(db, collection_name, id), {
        avatar: downloadURL,
        updatedOn: new Date()
      });

      // updateUser({ id: panelUser.id, avatar: downloadURL })
    })
  })
}

const updateEvent = (event: Event): Promise<Event | undefined> => {
  const db = getFirestore()

  event.dateCreated = undefined



  const fEvent = removeEmptyAttributes(event)

  if (fEvent.id) {
    const _activations = doc(db, collection_name, fEvent.id)

    const obj: DynamicObject = {};

    if (fEvent.name) {
      obj['name'] = fEvent.name?.toLowerCase();
    }

    if (fEvent.projectNo) {
      obj['projectNo'] = fEvent.projectNo?.toLowerCase();
    }

    obj['projectNo'] = fEvent.projectNo?.toLowerCase();

    // event.memoryMakers?.map((item, index) => {
    //   obj[item.label] = item.label.toLowerCase();
    // })

    //hunnain handle parents named here later
    // if (fEvent.parent.parentTitle?.label) {
    //   obj['parentTitle'] = fEvent.parent[0].parentTitle?.label?.toLowerCase();
    // }

    const tags = toValidStringArray(fEvent.tags, true);

    if (tags?.length) {
      tags.map((item: string, index: number) => {
        obj[item] = item;
      })
    }

    const subsequencesArray = simpleSubsequencesForObject(obj);

    // if (fEvent.isMicrosite) {
    //   subsequencesArray.push('isMicrosite')
    // }
    // if (fEvent.isDooh) {
    //   subsequencesArray.push('isDooh')
    // }
    // if (fEvent.isAnalytics) {
    //   subsequencesArray.push('isAnalytics')
    // }

    console.log("fEvent ", fEvent)

    console.log("removeEmptyAttributes(fEvent)", removeEmptyAttributes(fEvent))

    const printerDevices = toPrinterDevicesMap(event.printerDevices)
    const defaultPrinterDeviceId = getDefaultPrinterDeviceId(event.defaultPrinterDeviceId, printerDevices)
    const printerAssignments = getPrinterAssignments(event.printerAssignments, event.memoryMakers, printerDevices)

    const payload = {
      ...removeEmptyAttributes(fEvent),
      embedCode: event.isAnalytics ? (event.embedCode || "") : "",
      clients: toValidStringArray(event.clients),
      memoryMakers: toValidStringArray(fEvent.memoryMakers),
      printerDevices,
      defaultPrinterDeviceId,
      printerAssignments,
      frames: toValidStringArray(fEvent.frames),
      initialToolFrame: Boolean(fEvent.initialToolFrame),
      templates: toValidStringArray(fEvent.templates),
      tags: toValidStringArray(fEvent.tags, true),
      autoPrint: Boolean(fEvent.autoPrint),
      zearch: subsequencesArray.concat(fEvent.id.toLowerCase()),
      updatedOn: new Date(),
      // Only update microsite fields if event.isMicrositeDefault is false
      ...(event.isMicrositeDefault ? {} : {
        microsite: event.isMicrosite ? event.microsite : "",
        router: event.isRouter ? event.router : "",
        micrositeBeta: event.isMicrosite ? event.micrositeBeta : "",
        micrositeDate: (event.isMicrosite && event.micrositeDate) ? new Date(event.micrositeDate) : null,
        micrositeName: event.isMicrosite ? event.micrositeName : ""
      })
    }

    return new Promise(resolve => setDoc(_activations, payload, { merge: true })
      .then(() => updateDoc(_activations, {
        printerDevices,
        defaultPrinterDeviceId,
        printerAssignments,
      }))
      .then((response) => {
        console.log(response);
        resolve(event);
      }).catch(error => {
        console.log(error);
        resolve(undefined);
      }));
  }
  else {
    return new Promise(resolve =>
      resolve(undefined)
    )
  }
}

const createEvent = (event: Event): Promise<Event | undefined> => {

  return new Promise(resolve => {
    alert("Create Event is Non Functional")
  }
  );
  // const db = getFirestore();

  // console.log("creating event");

  // alert(event.id)

  // if (event.id) {
  //   const _activations = doc(db, collection_name, event.id);

  //   const obj: DynamicObject = {};

  //   if (event.name) {
  //     obj['name'] = event.name?.toLowerCase();
  //   }

  //   if (event.projectNo) {
  //     obj['projectNo'] = event.projectNo?.toLowerCase();
  //   }

  //   event.memoryMakers?.map((item, index) => {
  //     obj[item.label] = item.label.toLowerCase();
  //   });

  //   const tags = convertSelectToArr(event.tags);

  //   if (tags?.length) {
  //     const tags = convertSelectToArr(event.tags);
  //     tags.map((item: string, index: number) => {
  //       obj[item] = item;
  //     });
  //   }

  //   const subsequencesArray = simpleSubsequencesForObject(obj);

  //   return new Promise(resolve =>
  //     setDoc(_activations, { avatar: event.avatar, name: event.name, startDate: event.startDate, endDate: event.endDate, tags: convertSelectToArr(event.tags), info: event.info, zearch: subsequencesArray.concat(event.id ? event.id.toLowerCase() : "") }, { merge: true })
  //       .then((response) => {
  //         console.log(response);
  //         resolve(event);
  //       })
  //       .catch(error => {
  //         console.log(error);
  //         resolve(undefined);
  //       })
  //   );
  // } else {
  //   return new Promise(resolve =>
  //     resolve(undefined)
  //   );
  // }
};


type Info = {
  collections: number;
  contents: number;
};

const prepareForDeletion = (id: ID): Promise<Info> => {
  const db = getFirestore();

  const q = firebaseQuery(collection(db, "_collections"), where('events', 'array-contains', id));
  const q2 = firebaseQuery(collection(db, "_contents"), where('event', '==', id));

  const obj: Info = {
    collections: 0,
    contents: 0,
  };

  // Use Promise.all to wait for both asynchronous calls to complete
  return Promise.all([getDocs(q), getDocs(q2)])
    .then(([collectionsSnapshot, contentsSnapshot]) => {
      obj.collections = collectionsSnapshot.size;
      obj.contents = contentsSnapshot.size;

      return obj;
    })
    .catch((error) => {
      console.error(error);
      throw error; // Rethrow the error to propagate it further if needed
    });
};


const archiveEvent = (eventId: ID): Promise<void> => {
  const db = getFirestore();
  const collectionName = "archive" + collection_name;

  if (eventId) {
    const userDocRef = doc(db, collection_name, eventId);

    // Retrieve the document data
    return getDoc(userDocRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const userData = snapshot.data();

          // Set the document data in the new collection
          const archiveDocRef = doc(db, collectionName, eventId);
          return setDoc(archiveDocRef, userData)
            .then(() => {
              // Delete the document from the original collection
              return deleteDoc(userDocRef);
            })
            .catch((error) => {
              console.error("Error archiving user:", error);
              throw error;
            });
        } else {
          throw new Error("User document not found.");
        }
      })
      .catch((error) => {
        console.error("Error retrieving user document:", error);
        throw error;
      });
  } else {
    return Promise.reject(new Error("Invalid user ID"));
  }
}


const archiveSelectedEvents = (selectedIds: Array<ID>): Promise<void> => {
  const db = getFirestore();
  const collectionName = "archive" + collection_name;

  // Use Promise.all to run the promises concurrently
  const archivePromises = selectedIds.map(documentId => {
    if (documentId) {
      const userDocRef = doc(db, collection_name, documentId);

      // Retrieve the document data
      return getDoc(userDocRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const userData = snapshot.data();

            // Set the document data in the new collection
            const archiveDocRef = doc(db, collectionName, documentId);
            return setDoc(archiveDocRef, userData)
              .then(() => {
                // Delete the document from the original collection
                return deleteDoc(userDocRef);
              })
              .catch((error) => {
                console.error("Error archiving template:", error);
                throw error;
              });
          } else {
            throw new Error(`document with ID ${documentId} not found.`);
          }
        })
        .catch((error) => {
          console.error(`Error retrieving document with ID ${documentId}:`, error);
          throw error;
        });
    } else {
      return Promise.reject(new Error("Invalid ID"));
    }
  });

  // Return a promise that resolves when all archive operations are complete
  return Promise.all(archivePromises).then(() => { });
};

export { getEvents, archiveEvent, archiveSelectedEvents, getEventById, createEvent, updateEvent, uploadAndUpdate, getMemoryMakers, getPrinterDevices, getTemplates, getClients, prepareForDeletion, getFrames }

